import * as React from 'react';
import styles from './header-with-toolbar.scss';

import type { JSX } from "react";

export interface HeaderWithToolbarProps {
  title?: string;
  leftElement?: JSX.Element;
  className?: string;
  headerClassName?: string;
  hasLongDescription?: boolean;
  children?: React.ReactNode;
}

export const HeaderWithRightToolbar: React.FC<HeaderWithToolbarProps> = ({
  title, leftElement, className, headerClassName, hasLongDescription, children }) => (
  <div className={`row flex-nowrap justify-content-between ${styles.expanderHeader} 
        ${!!title ? 'has-title' : ''}  ${hasLongDescription && styles.longDescriptionTitle} ${headerClassName} dialog-expander-header`}>
    <div className={`col ${styles.title}`}>
      {!!title
        ? <h3 className={className}>{title}</h3>
        : (!!leftElement ? leftElement : null)}
    </div>
    <div className={` col col-auto ${styles.expanderCloseX} expander-close-x`}>
      <div className="d-flex">
        {children}
      </div>
    </div>
  </div>
);
